import(/* webpackMode: "eager", webpackExports: ["ScreenProvider"] */ "/vercel/path0/src/app/context/ScreenContext.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
